import { baseUrl } from "../../../App";
import axios from "axios";

const registerMentor = async (formData) => {
    const JsonFormData = JSON.stringify(formData);
    try {
        const response = await axios.post(
            `${baseUrl}/users/mentors`,
                {'body':JsonFormData},
                {'headers': {
                    'Content-Type': 'application/json; charset=utf-8'
                  }
                }
        )
        console.log(response)
        return response;
    } catch (error) {
        console.log(error);
    }
}

export default registerMentor